<template>
  <div>
    <div class="bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-3 pl-3 pr-3 mb-3">
      <div class="d-flex flex-column">
        <h4 class="mb-0">Sample Usage</h4>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
        <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="view" :codeSample="require('./select_sample.js').default">
      <template v-slot:preview>
        <div class="bg-white rounded shadow-sm p-3 w-100">
          <Select v-model="selected" :value="selected" :options="options"/>
          <p class="mt-2">Selected: <b>{{ selected }}</b></p>
        </div>
      </template>
    </CodePreviewViewer>
    </div>
  </div>
</template>

<script>
import Select from '@/components/export/Select/Select'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
  components: { ButtonGroup, CodePreviewViewer, Select },
  data () {
    return {
      view: 'preview',
      selected: null,
      options: [
        { text: 'Kobe Forrosuelo', value: 'user_1' },
        { text: 'John Doe', value: 'user_2' },
        { text: 'Kib Beck', value: 'user_3' },
        { text: 'Henri Koelpin', value: 'user_4' },
        { text: 'Tobin Rempel', value: 'user_5' },
        { text: 'Gina Weissnat', value: 'user_6' },
        { text: 'Ocie Mills', value: 'user_7' },
        { text: 'Alysa Homenick', value: 'user_8' },
        { text: 'Casper Dooley', value: 'user_9' },
        { text: 'Era Heaney', value: 'user_10' },
        { text: 'Alverta Pouros', value: 'user_11' },
        { text: 'Brandt Hamill', value: 'user_12' }
      ],
    }
  }
}
</script>

<style>

</style>